import React from 'react'

const Footer = () => {
  return (
    <footer id="main-footer" className="is-center py-1">
      <div className="container">
        <p>Copyright &copy; 2023, Marble Specialist, All Rights Reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
